import { render, staticRenderFns } from "./extrafield.vue?vue&type=template&id=759d1214&scoped=true"
import script from "./extrafield.vue?vue&type=script&lang=js"
export * from "./extrafield.vue?vue&type=script&lang=js"
import style0 from "./extrafield.vue?vue&type=style&index=0&id=759d1214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759d1214",
  null
  
)

export default component.exports